<template>
  <div class="floor4-wrapper">
    <div class="floor4-title">
      <img src="~images/floor4/title2.png" alt />
    </div>
    <div class="Floor4Swiper" @mouseenter="on_bot_enter" @mouseleave="on_bot_leave">
      <swiper :options="swiperOptionFloor4" ref="myFloor4Swiper">
        <swiper-slide v-for="(item, index) in infoData" :key="index">
          <div class="new" @click="showCart(item, index)">
            <div class="new-detail">
              <img :src="item.image" alt />
            </div>
            <div class="info">
              <p class="info-title">{{ item.title }}</p>
              <p class="info-desc">{{ item.digest ? item.digest : item.title }}</p>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="slide-index"></div>
    </div>
    <div class="new-shadow" v-if="shadowVisible"></div>

    <div class="new-card" v-if="shadowVisible">
      <div class="card">
        <div class="left">
          <div class="title">{{ cartData.title }}</div>
          <div class="content" v-html="htmlContent"></div>
        </div>
        <div class="right">
          <img :src="imgUrl" v-show="imgUrl" alt />
        </div>
      </div>
      <div class="close-icon" @click="closeCart">
        <img src="~images/floor4/close.png" alt />
      </div>
    </div>
  </div>
</template>

<script>
// import moment from 'moment'
import { getArticleList, getArticleDetail } from '@/api/index'
import { swiper, swiperSlide } from "vue-awesome-swiper";
import("swiper/dist/css/swiper.css");

export default {
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    mySwiper() {
      // mySwiper 是要绑定到标签中的ref属性
      return this.$refs.myFloor4Swiper.swiper;
    }
  },
  data() {
    return {
      swiperOptionFloor4: {
        //notNextTick: true,
        //循环
        //loop: true,
        //设定初始化时slide的索引
        slidesPerView: 4,
        spaceBetween: '7%',
        slidesPerGroup: 4,
        initialSlide: 0,
        //自动播放
        //autoplay:true,
        // autoplay: {
        //   delay: 3000
        // },
        //滑动速度
        speed: 800,
        //滑动方向
        direction: "horizontal",
        //滑动之后回调函数
        on: {
          slideChangeTransitionEnd: function() {
            // console.log(this.activeIndex);//切换结束时，告诉我现在是第几个slide
          }
        },
        //分页器设置
        pagination: {
          el: ".slide-index",
          clickable: true
        }
      },
      infoData: [],
      shadowVisible: false,
      cartData: {},
      imgUrl: '',
      htmlContent: ''
    };
  },
  mounted() {
    getArticleList({ page: 1, pageCount: 10, category: 108 }).then(res => {
      const { data } = res || {}
      this.infoData = data && data.articleViewList || []
      getArticleList({ page: 1, pageCount: 10, category: 109 }).then(res => {
        const { data } = res || {}
        this.infoData = this.infoData.concat(data && data.articleViewList || [])
      })
    })
  },
  methods: {
    showCart(item, value) {
      this.shadowVisible = true;

      const { id } = item || {}
      getArticleDetail(id).then(res => {
        const { data } = res || {}
        this.cartData = data
        this.dealData(data)
      })
    },
    closeCart() {
      this.shadowVisible = false
      this.cartData = {}
      this.imgUrl = ''
      this.htmlContent = ''
    },
    //通过获得的swiper对象来暂停自动播放
    on_bot_enter() {
      // console.log(this.mySwiper.autoplay, "this.$refs.mySwiper.autoplay");
      //this.mySwiper.autoplay.stop();
    },
    on_bot_leave() {
      //this.mySwiper.autoplay.start();
    },
    dealData(data) {
      const { createTime, content,image } = data
      // this.cartDate = moment(new Date(createTime)).format('YYYY.MM.DD')

      let imgReg = /<img.*?(?:>|\/>)/gi
      let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i
      let arr = content.match(imgReg) || []

      let srcArr = []
      for (let i = 0; i < arr.length; i++) {
        let src = arr[i].match(srcReg)
        // 获取图片地址
        srcArr.push(src && src[1])
      }

      let rawContent = content.replace(imgReg, '')
      this.htmlContent = rawContent
      this.imgUrl = image || (srcArr && srcArr[0] )
    }
  }
};
</script>

<style scoped lang="less">
.floor4-wrapper {
  width: 100%;
  height: 100%;
  background-image: url(~images/floor4/bg.png);
  background-repeat: no-repeat;
  background-size: cover;
  min-width: 1200px;
  position: relative;
  .floor4-title {
    position: absolute;
    top: 22.5%;
    left: 7.5%;
    img {
      width: 37%;
      display: inline-block;
    }
  }
  .Floor4Swiper {
    position: absolute;
    top: 40%;
    left: 50%;
    margin-left: -42.5%;
    width: 85%;
    //height: 36.1%;
    //background-color: red;
    .swiper-container {
      width: 100%;
      height: 100%;
      .swiper-wrapper {
        width: 100%;
        .swiper-slide {
          width: 100%;
          .new {
            width: 100%;
            height: 100%;
            cursor: pointer;
            .new-detail {
              width: 100%;
              height: 100%;
              img {
                width: 100%;
                height: 28vh;
                display: block;
                border: 0;
                background: #000;
                opacity: 0.7;
                // object-fit: cover;
              }
            }
            .new-detail-replace {
              img {
                opacity: 1;
              }
            }
            .info {
              padding-left: 7%;
              padding-top: 14px;
              padding-bottom: 12px;
              background: rgba(10, 10, 10, 1);
              color: #fff;
              .info-title {
                font-size: 18px;
                margin: 0;
                font-weight: 600;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
              .info-desc {
                font-size: 14px;
                margin: 0;
                margin-top: 12px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
              .info-title-replace {
                font-size: 18px;
                margin: 0;
                font-weight: 600;
                opacity: 0.5;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
              .info-desc-replace {
                font-size: 14px;
                margin: 0;
                margin-top: 12px;
                color: #0a0a0a;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
            }
          }
        }
      }
    }

    .slide-nav {
      width: 100%;
      margin-top: 10%;
      cursor: pointer;
      .slide-icon {
        .slide-icon-img {
          width: 8.5%;
          margin-right: 6%;
        }
        .slide-icon-img:last-child {
          margin-right: 0;
        }
      }
    }
  }
  .new-shadow {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 300;
    background-color: #000;
    opacity: 0.7;
  }
  .new-card {
    width: 90%;
    height: 64%;
    background: rgba(30, 30, 30, 1);
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 400;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    .card {
      width: 89%;
      height: 72%;
      display: flex;
      justify-content: space-between;
      color: #fff;
      .left {
        width: 45%;
        .date {
          font-size: 24px;
          font-weight: 600;
          opacity: 0.5;
        }
        .title {
          font-size: 26px;
          color: #fff;
        }
        .content {
          margin-top: 3%;
          font-size: 12px !important;
          height: 75%;
          overflow: auto;
          opacity: 0.8;
        }
      }
      .right {
        width: 49%;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
    .close-icon {
      position: absolute;
      right: 20px;
      top: 20px;
      width: 26px;
      height: 26px;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
<style lang="less">
.slide-index {
  position: absolute;
  left: 50%;
  top: 109%;
  transform: translate(-50%, -50%);
  // margin: 0 auto;
  .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 43px;
    background-color: #fff !important;
  }
  .swiper-pagination-bullet:last-child {
    margin-right: 0;
  }
  .swiper-pagination-bullet-active {
    opacity: 1;
    background: #ffff40 !important;
  }
  .swiper-pagination-bullet-active:after {
    content: "";
    display: block;
    box-sizing: border-box;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid #ffff40;
    position: relative;
    top: -5px;
    left: -5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/floor/floor_4.vue